import React from 'react';
import { Row, Col } from 'reactstrap';
import MiniCard from '../Common/MiniCard';

const TokenSummary = ({ summary }) => {
  const summaryCards = [
    {
      title: 'Total',
      text: summary.total,
      icon: 'bx bx-globe',
      color: 'primary',
    },
    {
      title: 'Active',
      text: summary.active,
      icon: 'bx bx-check-circle',
      color: 'success',
    },
    {
      title: 'Expiring',
      text: summary.warning,
      icon: 'bx bx-time',
      color: 'warning',
    },
    {
      title: 'Critical',
      text: summary.critical,
      icon: 'bx bx-error',
      color: 'danger',
    },
    {
      title: 'Expired',
      text: summary.expired,
      icon: 'bx bx-x-circle',
      color: 'dark',
    },
  ];

  return (
    <Row>
      {summaryCards.map((card, index) => (
        <Col key={index} xl="2" md="4" sm="6">
          <MiniCard {...card} loading={false} />
        </Col>
      ))}
    </Row>
  );
};

export default TokenSummary;
